// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","footer-container":"Footer_footer-container__GtyuM","logo":"Footer_logo__+SElo","logo-flex":"Footer_logo-flex__6w9qh"};